<template>
<div class="award">
  <div class="award-media">
      <img v-if="item.image" :src="item.image" :alt="item.imageAltText" :srcset="item.imageSrcSet" :sizes="item.imageSizes">
  </div>
  <div class="award-details">
      <h3 class="hdg hdg_date">{{ item.headline | truncate(50, '...')}}</h3>
      <p>{{item.summary | truncate(80, '...')}}</p>
      <div>
          <a :href="item.readMoreLink" class="iconCta">
              <div class="iconCta-text">{{readMoreCopy}}</div>
              <div class="iconCta-icon">
                  <i class="icon icon_chevron"></i>
              </div>
          </a>
      </div>
  </div>
</div>
</template>

<script>
export default {
  props: ['item', 'readMoreCopy']
}
</script>
